export enum UserDivision {
  WCM = 'WCM',
  WMG = 'WMG',
  WMG_WCM = 'WMG_WCM',
  WCM_WMG = 'WCM_WMG'
}
